import { render, staticRenderFns } from "./NotificationExceptionEventIcon.vue?vue&type=template&id=5728da1a&"
import script from "./NotificationExceptionEventIcon.vue?vue&type=script&lang=ts&"
export * from "./NotificationExceptionEventIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports